export default function openLinkInNewTab(href, newTab) {
  if (newTab) {
    window.open(href, '_blank').focus();
  } else {
    const a = document.createElement('a');
    a.href = href;
    a.click();
  }
}
